import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import './index.css';

export type BreadcrumbItem = {
  path?: string;
  label: string;
};

type Props = {
  children?: never;
  items: BreadcrumbItem[];
};

export const Breadcrumb: FC<Props> = ({ items }) => {
  const { t } = useTranslation();
  return (
    <div className="breadcrumb">
      <ul>
        <li>
          <Link to="/">{t('pages.home.title')}</Link>
        </li>
        {items.map((item) => {
          return (
            <li key={item.label}>
              {item.path ? (
                <Link to={item.path}>{item.label}</Link>
              ) : (
                <span>{item.label}</span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
